module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/neujahr-8e880ce2d8e96a47675f9ee6dd50e3fd.svg";